import $ from 'jquery';
import keyMirror from 'keymirror';
import objectAssign from 'object-assign';
import { bindActionCreators } from 'redux';
import update from 'immutability-helper';

const Actions = keyMirror({
  SEARCH_FAILED: null,
  SEARCH_REQUESTED: null,
  SEARCH_RESULTS_RECEIVED: null,
  SEARCH_NEXT_PAGE_REQUESTED: null,
  SEARCH_NEXT_PAGE_RECEIVED: null,
});

function searchUrl (termType) {
  switch (termType) {
  case 'band': return '/search/bands';
  case 'club': return '/search/clubs';
  case 'fundraiser': return '/search/fundraisers';
  case 'user': return '/search/users';
  case 'team': return '/search/teams';
  case 'school': return '/search/schools';
  default:
    return '';
  }
}

const Commands = {
  search: function search (termType, term, options = {}) {
    return (dispatch, getState) => {
      let url = searchUrl(termType);
      if (!url) {
        return;
      }
      let state = getState().results;
      if (state.loading || !termType || !term) {
        return;
      }
      dispatch({
        type: Actions.SEARCH_REQUESTED,
      });
      let params = objectAssign(options, {
        term: term,
      });
      $.postJSON(url, params).done(data => {
        dispatch({
          type: Actions.SEARCH_RESULTS_RECEIVED,
          data: data,
        });
      }).error(() => {
        dispatch({
          type: Actions.SEARCH_FAILED,
        });
      });
    };
  },
  nextPage: function nextPage () {
    return (dispatch, getState) => {
      let state = getState();
      if (!state.results.nextPageUrl) {
        return;
      }
      dispatch({
        type: Actions.SEARCH_NEXT_PAGE_REQUESTED,
      });
      $.postJSON(state.results.nextPageUrl).done(data => {
        dispatch({
          type: Actions.SEARCH_NEXT_PAGE_RECEIVED,
          data: data,
        });
      }).error(() => {
        dispatch({
          type: Actions.SEARCH_FAILED,
        });
      });
    };
  },
};

export function mapDispatch (dispatch) {
  return {
    cmd: bindActionCreators(Commands, dispatch),
  };
}

const initialState = {
  joinedTeams: [],
  results: {
    term: '',
    termType: '',
    loading: false,
    items: null,
    nextPageUrl: '',
  },
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
  case Actions.SEARCH_FAILED:
    return update(state, {
      results: {
        loading: {$set: false},
      },
    });
  case Actions.SEARCH_NEXT_PAGE_REQUESTED:
    if (!state.nextPageUrl) {
      return state;
    }
    return update(state, {
      results: {
        loading: {$set: true},
      },
    });
  case Actions.SEARCH_REQUESTED:
    return update(state, {
      results: {
        loading: {$set: true},
        nextPageUrl: {$set: ''},
      },
    });
  case Actions.SEARCH_NEXT_PAGE_RECEIVED:
    return receivedResults(state, action);
  case Actions.SEARCH_RESULTS_RECEIVED:
    return receivedResults(state, action, {firstPage: true});
  default:
    return state;
  }
}

function receivedResults (state, action, options = {}) {
  const data = action.data;
  return update(state, {
    joinedTeams: {
      $push: data.joined_team_ids || [],
    },
    results: {
      loading: {$set: false},
      term: {$set: data.term},
      termType: {$set: data.term_type},
      nextPageUrl: {$set: data._links.next ? data._links.next.href : ''},
      items: options.firstPage ? {$set: data._embedded.items} : {$push: data._embedded.items},
    },
  });
}

export function mapState (state) {
  return {
    search: state,
  };
}
